import {
	type Currency,
	Dtos,
	type FinancialPeriodId,
	type ISODate,
	type SuretyAccountId,
	UserType,
} from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { financialPeriodsQueryKey } from "./financials.keys";

export function useUpdateFinancialPeriodBlocSize(accountId: SuretyAccountId) {
	const { patch } = useRequest();
	const queryClient = useQueryClient();
	const { user } = useAuthenticatedUser();

	return useMutation({
		mutationFn: async ({
			periodId,
			periodEndDate,
			blocSize,
		}: {
			periodId?: FinancialPeriodId;
			periodEndDate: ISODate;
			blocSize: Currency;
		}) => {
			if (user.type === UserType.admin) {
				if (!periodId) {
					throw new Error("periodId is required to update BLOC size as an admin");
				}
				const body: Dtos.Admin.FinancialPeriod.Update.BlocSize.Request = { blocSize };
				return await patch<Dtos.Admin.FinancialPeriod.Get.Response>(
					`/v2/admin/surety/accounts/${accountId}/financial-periods/${periodId}/bloc-size`,
					body,
				);
			}

			const body: Dtos.Agent.FinancialPeriod.BlocSize.Update.Request = {
				fyeDate: periodEndDate,
				blocSize,
			};
			return await patch<Dtos.Admin.FinancialPeriod.Get.Response[]>(
				`/v2/surety/accounts/${accountId}/financial-periods/bloc-size`,
				body,
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});
}
